import { useMutation } from "@apollo/client";
import { REMOVE_TASK } from "../task.queries";
import {
  RemoveTaskMutation,
  RemoveTaskMutationVariables,
} from "../../../__generated__/RemoveTaskMutation";

export const useRemoveTask = () => {
  return useMutation<RemoveTaskMutation, RemoveTaskMutationVariables>(
    REMOVE_TASK,
    {
      refetchQueries: "active",
    }
  );
};
